import { Seo, Reveal, Overline, GlassCard } from "@/components/site/primitives";
import { OButton } from "@/components/site/OButton";
import { IMG } from "@/data/site";

const VALUES = [
  { title: "Systems, not features", text: "We build complete intelligent systems where AI sits at the centre of the business." },
  { title: "Infrastructure-minded", text: "Secure, scalable and reliable foundations designed for the long term." },
  { title: "Industry focused", text: "Deep, industry-specific intelligence — starting with construction." },
  { title: "Long-term & ambitious", text: "Building the intelligence layer for the industries that power the real world." },
];

export default function Company() {
  return (
    <div className="pt-36 pb-32">
      <Seo title="Company — ORAYA" description="We build systems, not software features. ORAYA embeds AI into the operating layer of complex businesses." path="/company" />
      <div className="oraya-container">
        <Reveal>
          <Overline>Company</Overline>
          <h1 className="display text-4xl sm:text-6xl font-light tracking-tight leading-[1.05] text-gradient-mist mt-6 max-w-4xl">
            We build systems, not software features.
          </h1>
        </Reveal>

        <div className="grid md:grid-cols-12 gap-12 mt-16">
          <Reveal className="md:col-span-7">
            <p className="text-lg text-subtle leading-relaxed">
              ORAYA is building a new generation of intelligent systems where AI is embedded into the operating
              layer of complex businesses. We don't build generic AI tools or simple chatbots — we build complete
              systems that connect intelligence, data, workflows, decisions, execution and learning.
            </p>
            <p className="text-lg text-subtle leading-relaxed mt-6">
              Our first major industry system is ConstructONS.AI, the AI operating system for construction business.
              It is the beginning of an ecosystem designed to expand across the industries that power the world.
            </p>
          </Reveal>
          <Reveal delay={0.15} className="md:col-span-4 md:col-start-9">
            <GlassCard className="p-8">
              <p className="display text-2xl font-light text-ink leading-snug">Intelligence, engineered.</p>
              <div className="w-10 h-px bg-hairline/15 my-6" />
              <p className="text-subtle">Don't build another tool. Build the system.</p>
            </GlassCard>
          </Reveal>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6 mt-20">
          {VALUES.map((v, i) => (
            <Reveal key={v.title} delay={i * 0.08}>
              <GlassCard variant="medium" hover className="p-8 h-full" data-testid={`company-value-${i}`}>
                <h3 className="display text-lg font-medium text-ink">{v.title}</h3>
                <p className="text-sm text-subtle mt-3 leading-relaxed">{v.text}</p>
              </GlassCard>
            </Reveal>
          ))}
        </div>
      </div>

      <section className="oraya-container mt-24">
        <Reveal>
          <div className="relative rounded-3xl overflow-hidden min-h-[300px] md:min-h-[420px] glass-heavy flex items-end">
            <img src={IMG.building} alt="Minimalist modern architecture representing real-world industries" className="absolute inset-0 w-full h-full object-cover opacity-70" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-surface to-transparent" />
            <div className="relative p-10 md:p-14 max-w-xl">
              <h3 className="display text-3xl md:text-4xl font-light text-ink">Building the intelligence layer for the real world.</h3>
              <div className="mt-6"><OButton to="/careers" variant="primary" icon>Join ORAYA</OButton></div>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
